import React, { useEffect, useState } from "react";
import ButtonUp from "../../Components/buttonUp";
import MusicBg from "../../Components/musicBg";
import Acara from "../Acara";
import Couple from "../Couple";
import Cover from "../Cover";
import Gallery from "../Gallery";
import Home from "../Home";
import Penutup from "../Penutup";
import Reservasi from "../Reservasi";
import MusicWedding from "../../Music/musik.mp3";
import BottomBar from "../../Components/bottomBar";

export default function Beranda() {
  const [showUp, setShowUp] = useState(false);
  const [btnUp, setBtnUp] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [audio] = useState(new Audio(MusicWedding));
  const [fadein, setFadein] = useState(false);
  const [vMusik, setVmusik] = useState(false);

  const toggle = () => setPlaying(!playing);

  const bukaUndangan = () => {
    window.scrollTo(0, 0);
    setShowUp(true); // Membuka cover
    toggle(); // Memainkan musik
    setFadein(true); // Memulai animasi
  };

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  // 👇 PERBAIKAN 1: Kunci Scroll Secara Absolut di Awal 👇
  useEffect(() => {
    if (!showUp) {
      // Jika Cover belum dibuka, kunci scroll mati-matian
      document.body.style.overflow = "hidden";
    } else {
      // Jika Cover sudah dibuka, biarkan tamu bebas scroll
      document.body.style.overflow = "auto";
    }

    // Cleanup function untuk mencegah bug saat pindah halaman
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showUp]);

  const vBtnTop = () => {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      setBtnUp(true);
    } else {
      setBtnUp(false);
    }
  };

  const onMusic = () => {
    setVmusik(true);
  };

  const onCloseMusic = () => {
    setVmusik(false);
  };

  useEffect(() => {
    window.onscroll = function () {
      vBtnTop();
    };
    playing ? audio.play() : audio.pause();
    audio.loop = true;
  }, [playing, audio]);

  return (
    // 👇 PERBAIKAN 2: Bungkus semua dengan div pelindung khusus iOS 👇
    // iOS (iPhone) sering membobol document.body.overflow, jadi kita tambah proteksi ganda di sini.
    <main
      className={
        showUp ? "w-full overflow-hidden" : "w-full h-screen overflow-hidden"
      }
    >
      <Cover transformUp={showUp} onClick={bukaUndangan} />

      {/* 👇 PERBAIKAN 3: Syarat Ganda untuk ButtonUp 👇
          ButtonUp HANYA boleh muncul jika layar di-scroll (btnUp) DAN undangan sudah dibuka (showUp) */}
      <ButtonUp visible={btnUp && showUp} onClick={() => scrollToTop()} />

      <MusicBg
        onClick={toggle}
        statsPlay={playing}
        visible={vMusik}
        onClose={() => onCloseMusic()}
      />

      <BottomBar
        visible={showUp && !vMusik}
        onMusic={() => {
          onMusic();
        }}
      />

      <Home fadeIn={fadein} />
      <Couple />
      <Acara />
      <Gallery />
      <Reservasi />
      <Penutup />
    </main>
  );
}
